module.exports = __webpack_public_path__ + "components/rewards/skiset/static/icon-1bd90c9d6e8ab758a58cf91d4a8375cc.svg";